import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';
import { connect } from 'react-redux';

import * as CommonStateSelectors from 'State/selectors';
import { InputField } from 'Common/SemanticWrapper';
import { CLOSE_PRODUCTION_FORM_NAME } from 'Common/FormEnum';
import { CloseProductionFieldEnum } from 'Common/FieldEnum';

const UserNameField = ({ userName, isReadOnly }) => (
  <Field
    label={'Sign and Verify'}
    infoMessage={`By entering your username, ${_.toUpper(
      userName
    )}, you are verifying this production record is complete and accurate.`}
    name={CloseProductionFieldEnum.SignAndVerify}
    component={InputField}
    hideEmptyError
    disabled={isReadOnly}
    fluid
  />
);

class CloseProductionForm extends Component {
  static propTypes = {
    index: PropTypes.number,
    isReadOnly: PropTypes.bool,
  };

  static defaultProps = {
    index: 0,
  };

  render() {
    const { userName, isReadOnly } = this.props;

    return <UserNameField userName={userName} isReadOnly={isReadOnly} />;
  }
}
const validate = (values, props) => {
  const errors = {};
  const { userName } = props;

  if (
    _.toUpper(userName) !==
    _.toUpper(values[CloseProductionFieldEnum.SignAndVerify])
  ) {
    errors[CloseProductionFieldEnum.SignAndVerify] =
      'Please enter your username to verify.';
  }
  return errors;
};

const mapStateToProps = (state, props) => ({
  userName: CommonStateSelectors.getUserName(state),
});

CloseProductionForm = connect(mapStateToProps)(
  reduxForm({
    form: CLOSE_PRODUCTION_FORM_NAME,
    validate,
  })(CloseProductionForm)
);

export { CloseProductionForm, UserNameField, validate };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/CloseProductionForm.js